exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".subtitle-page{font-size:25px;font-size:1.5625rem}@media (min-width:768px){.subtitle-page{font-size:30px;font-size:1.875rem}}", ""]);

